import { arcgisServerBaseUrl } from "./mapConfig";

export const reportEndpoint = "https://nvr-api.mapshare.vic.gov.au/report";

export const exportShapefileTask =
  arcgisServerBaseUrl + "/NVR/NVR_Utilities/GPServer/ExportToShapefile";

export const locationDetailsTask =
  arcgisServerBaseUrl + "/NVR/NVR_Geoprocessing/GPServer/GetLocationDetails";

export const removalReportTask =
  arcgisServerBaseUrl +
  "/NVR/NVR_Geoprocessing/GPServer/CalculateRemovalReportResults";

export const offsetReportTask =
  arcgisServerBaseUrl +
  "/NVR/NVR_Geoprocessing/GPServer/CalculateOffsetReportResults";

export const polygonFields: any = [
  { name: "OBJECTID", type: "oid" },
  { name: "id", type: "string", length: 50 },
  { name: "type", type: "string", length: 50 },
];

export const treeFieldNames: any = {
  type: "type",
  cmType: "meas_type",
  cm: "meas",
  vegCode: "veg_code",
  benchmark: "lt_val",
};

export const treeFields: any = [
  { name: "OBJECTID", type: "oid" },
  { name: "id", type: "string", length: 50 },
  { name: treeFieldNames.type, type: "string", length: 50 },
  { name: treeFieldNames.cmType, type: "string", length: 50 },
  { name: treeFieldNames.cm, type: "double" },
  { name: treeFieldNames.vegCode, type: "string", length: 50 },
  { name: treeFieldNames.benchmark, type: "string", length: 50 },
];

export const locationDetailsParams = {
  addresses: { index: 0 },
  localGovernmentAreas: { index: 1 },
  catchmentManagementAuthorities: { index: 2 },
  registeredAboriginalParties: { index: 3 },
  featuresCentroid: { index: 4 },
};

export const removalReportOutputParams = {
  proposedRemovalArea: { index: 0 },
  totalRemovalArea: { index: 1, label: "Total extent", unit: "ha" },
  treesLargeCount: { index: 2, label: "Large Trees" },
  patchesArea: { index: 3, label: "Proposed removal - Patches", unit: "ha" },
  endangeredEvcsRemovalArea: {
    index: 4,
    label: "Includes endangered EVCs",
    unit: "ha",
  },
  patchTreesLargeCount: { index: 5, label: "Large Patch Trees" },
  patchTreesArea: {
    index: 6,
    label: "Proposed removal - Patch Trees (outside of a mapped patch)",
    unit: "ha",
  },
  patchTreesSmallCount: { index: 7 },
  scatteredTreesArea: {
    index: 8,
    label: "Proposed removal - Scattered Trees",
    unit: "ha",
  },
  scatteredTreesSmallCount: { index: 9, label: "Small Scattered Trees" },
  scatteredTreesLargeCount: { index: 10, label: "Large Scattered Trees" },
  locationRisk: { index: 11 },
  assessmentPathway: { index: 12 },
  generalOffsetAmount: {
    index: 13,
    label: "General offset amount",
    unit: "General Habitat Units",
  },
  minimumStrategicBiodiversityScore: {
    index: 14,
    label: "Minimum strategic biodiversity value score",
  },
  outputPastRemovalArea: {
    index: 17,
    label: "Past removal",
    unit: "ha",
  },
};

export const offsetReportOutputParams = {
  totalOffsetArea: { index: 0, label: "Total extent", unit: "ha" },
  treesLargeCount: { index: 1, label: "Large Trees" },
  patchesArea: { index: 2, label: "Patches", unit: "ha" },
  scatteredTreesArea: { index: 3, label: "Scattered Trees", unit: "ha" },
  revegetationAreasArea: { index: 4, label: "Revegetation", unit: "ha" },
  habitatGain: { index: 5, label: "General Habitat Units" },
  strategicBiodiversityScore: {
    index: 6,
    label: "Strategic Biodiversity Value Score",
  },
};
